import { Box, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

import { getSettingState } from "../../../../redux/features/settingSlice";
import Category from "../Category";

const EmptyExplore = () => {
  const { categoryExplor, searchExplore } = useSelector(getSettingState);

  return (
    <Box sx={{ mb: "40px", mt: "70px" }}>
      {searchExplore ? (
        <Box>
          <Typography
            sx={{ display: "inline-block", fontSize: "22px", mb: "14px" }}
          >
            Unfortunately, we couldn't find any table that matches
            <Typography
              component={"span"}
              sx={{
                fontWeight: 700,
                display: "inline-block",
                px: "3px",
                fontSize: "20px",
              }}
            >
              {searchExplore}
            </Typography>
            !
          </Typography>
          <Typography sx={{ fontSize: "18px", color: "textField.main" }}>
            Please search a new term!
          </Typography>
        </Box>
      ) : (
        <>
          <Box sx={{ mb: "22px" }}>
            <Typography
              sx={{ display: "inline-block", fontSize: "22px", mb: "14px" }}
            >
              Unfortunately, there is no table in the
              <Typography
                component={"span"}
                sx={{
                  fontWeight: 700,
                  display: "inline-block",
                  px: "3px",
                  fontSize: "20px",
                }}
              >
                {categoryExplor?.name}
              </Typography>
              category!
            </Typography>
            <Typography sx={{ fontSize: "18px", color: "textField.main" }}>
              Please check other categories!
            </Typography>
          </Box>
          <Category />
        </>
      )}
    </Box>
  );
};

export default EmptyExplore;
